import React, { useMemo } from 'react';
import { BeveledPanel } from './BeveledPanel';
import { getCyanLedMaterial, getGreenLedMaterial } from './equipmentMaterials';

export type EquipmentLightsProps = {
  width: number;
  height: number;
  depth: number;
  opacity?: number;
  ledIntensity?: number;
  /** Vertical cyan strips flanking the front glass bay */
  showVerticalStrips?: boolean;
  /** Horizontal status bar above chamber */
  showStatusBar?: boolean;
  position?: [number, number, number];
};

/** Cyan LED strips and green status indicators — reference FAB accent lighting. */
export const EquipmentLights: React.FC<EquipmentLightsProps> = ({
  width,
  height,
  depth,
  opacity = 1,
  ledIntensity = 1,
  showVerticalStrips = true,
  showStatusBar = true,
  position = [0, 0, 0],
}) => {
  const cyan = useMemo(() => getCyanLedMaterial(ledIntensity * 0.85, opacity), [ledIntensity, opacity]);
  const green = useMemo(() => getGreenLedMaterial(0.7, opacity), [opacity]);
  const stripW = width * 0.014;
  const stripD = depth * 0.022;

  return (
    <group name="LED_Strips" position={position}>
      {showVerticalStrips
        ? ([-1, 1] as const).map((side) => (
            <BeveledPanel
              key={`v-strip-${side}`}
              size={[stripW, height * 0.52, stripD]}
              material={cyan}
              position={[side * width * 0.44, height * 0.08, depth * 0.02]}
            />
          ))
        : null}
      {showStatusBar ? (
        <>
          <BeveledPanel
            size={[width * 0.38, height * 0.012, stripD]}
            material={green}
            position={[-width * 0.12, height * 0.28, depth * 0.025]}
          />
          <BeveledPanel
            size={[width * 0.12, height * 0.012, stripD]}
            material={cyan}
            position={[width * 0.18, height * 0.28, depth * 0.025]}
          />
        </>
      ) : null}
    </group>
  );
};

export default EquipmentLights;
